import { SAVE_SEARCH_USERS, SAVE_USER } from '../constants/actionTypes.js'

const initialState = {
  logged_in: false,
  searchUsers: [],
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_USER:
      return Object.assign({}, state, action.user)
    case SAVE_SEARCH_USERS:
      return Object.assign({}, state, { searchUsers: action.searchUsers })
    default:
      return state
  }
}

export { userReducer }
